/**
 * @generated SignedSource<<3f1c6cd6494336472f6b32776e1b4252>>
 * @relayHash 8ce6c444a2fa7276cb4da3d1a791d300
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b

import type { ConcreteRequest } from 'relay-runtime';
export type useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery$variables = {
  contentId: string;
};
export type useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly metadata: {
        readonly frontend: {
          readonly embeddedWithMigration: boolean;
        } | null;
      };
      readonly type: string | null;
    } | null> | null;
  } | null;
};
export type useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery = {
  response: useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery$data;
  variables: useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "embeddedWithMigration"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8ce6c444a2fa7276cb4da3d1a791d300",
    "id": "2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b",
    "metadata": {},
    "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
    "operationKind": "query",
    "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
  }
};
})();

(node as any).hash = "e811ca917e234d313519ff2281e9d6fc";

export default node;
